import { render, staticRenderFns } from "./LotsTraceabilityList.vue?vue&type=template&id=e3848366&scoped=true"
import script from "./LotsTraceabilityList.vue?vue&type=script&lang=js"
export * from "./LotsTraceabilityList.vue?vue&type=script&lang=js"
import style0 from "./LotsTraceabilityList.vue?vue&type=style&index=0&id=e3848366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3848366",
  null
  
)

export default component.exports